'use client';

import Script from 'next/script';

import styles from '@/app/[lng]/page.module.scss';
import Header from '@/components/global/navigations/header';
import { CustomerDetailProvider } from '@/context/customer-detail-context';

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <CustomerDetailProvider>
      <meta httpEquiv="Status" content="503 Service Unavailable" />
      <Header trailways={process.env.TRAILWAYS_SITE_BASE}></Header>
      <div className={styles.page_not_found_container}>
        <main>
          <article>
            <header>
              <h1>Oops!</h1>
            </header>
            <div>
              <p>We are having problems with your request</p>
              <h2>Please try again</h2>
              <p>
                <a href="/" className={styles.button}>
                  Back Home
                </a>
              </p>
            </div>
          </article>
        </main>
      </div>
      <Script id="google-analytics">
        {`
          try {
            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
              'event': 'GAEvent',
              'eventCategory': '404 Page Reached',
              'eventAction' : window.location.href,
              'eventNonInteraction': true,
              'eventCallback' : function() {
              }
            });
          } catch (err) {}
        `}
      </Script>
    </CustomerDetailProvider>
  );
}
